import JobActionsOption from './styled';

export default JobActionsOption;
